import app from 'app';
import templateUrl from './activity.html';
import './activity.scss';

import './timeline/timeline';
import './family/family';
import './summary/summary';

import { logEvent, eventCategories } from 'helpers/analytics';

function ActivityCtrl(PlanMembership) {
  const Activity = this;

  Activity.$onInit = () => {
    PlanMembership.getPlanMemberships(Activity.currentSponsorship.id).then(
      memberships => {
        Activity.family = memberships.coveredMembers;
        Activity.showFamily =
          Activity.family.length > 1 && Activity.isSubscriber;
        Activity.hasDental = memberships.hasCurrentDentalMembership;
        Activity.hasVision = memberships.hasCurrentVisionMembership;

        if (!memberships.canSubmitClaim()) {
          Activity.hideSummary = true;
        }
      }
    );
  };

  Activity.submitClaimClicked = () => {
    logEvent('submitClaimButtonClicked', {
      category: eventCategories.MSOON
    });
  };
}

app.component('activity', {
  bindings: {
    currentUser: '<',
    currentSponsorship: '<',
    sponsorshipPeriod: '<',
    isSubscriber: '<'
  },
  controller: ActivityCtrl,
  controllerAs: 'Activity',
  templateUrl
});

export default 'activity';
